export default __webpack_public_path__ + "static/media/logo.b5aae01e.png";